import reviewsSelector from './selector';
import { showReviewCount } from '../../../config/ab/selector';

export default function mapStateToProps(state) {
    const reviews = reviewsSelector(state);
    const shouldRenderReviewCount = showReviewCount(state);

    return {
        ...reviews,
        shouldRenderReviewCount,
    };
}
